import { render, staticRenderFns } from "./leave-application.vue?vue&type=template&id=70f0d2cc&"
import script from "./leave-application.vue?vue&type=script&lang=js&"
export * from "./leave-application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports